module.exports = __webpack_public_path__ + "img/s2-1.55da37b4.jpg";